


























































import { Vue, Component, Prop } from 'vue-property-decorator'
import type { TaiwanEnroll } from '@/models/enrolls/taiwanEnroll'

@Component
export default class ActivitiesForm extends Vue {
  @Prop({ required: true }) value!: TaiwanEnroll
  @Prop({ default: false }) print!: boolean
  @Prop({ default: '' }) title!: string

  get form() {
    return this.value
  }

  set form(value: TaiwanEnroll) {
    if (!this.print) {
      this.$emit('update:value', value)
    }
  }
}
